module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[36]157.cbe0dcc.woff2";